import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import BedtimeOutlinedIcon from "@mui/icons-material/BedtimeOutlined";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import { corAlimentacao, sintomasDe } from "./rotinaUtil";

const Alimentacao = ({ value }) =>
  value ? (
    <Chip size="small" variant="outlined" color={corAlimentacao(value)} label={value} />
  ) : (
    <Typography variant="body2" color="text.disabled">
      --
    </Typography>
  );

/** Rotina de cada aluno em um dia do integral. */
const IntegralRotinaTable = ({ listaIR, onSelect }) => {
  if (listaIR.length === 0) {
    return (
      <Box
        sx={{
          py: 6,
          textAlign: "center",
          color: "text.secondary",
          border: 1,
          borderStyle: "dashed",
          borderColor: "divider",
          borderRadius: 2,
        }}
      >
        <PeopleOutlineIcon fontSize="large" />
        <Typography variant="body2" mt={1}>
          Nenhum aluno com rotina neste dia.
        </Typography>
      </Box>
    );
  }

  return (
    <TableContainer sx={{ border: 1, borderColor: "divider", borderRadius: 2 }}>
      <Table size="small" sx={{ minWidth: 720 }} aria-label="Rotina dos alunos">
        <TableHead>
          <TableRow sx={{ "& th": { fontWeight: 600, bgcolor: "action.hover" } }}>
            <TableCell>Aluno</TableCell>
            <TableCell>Lanche</TableCell>
            <TableCell>Almoço</TableCell>
            <TableCell align="center">Descanso</TableCell>
            <TableCell>Saúde</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {listaIR.map((ir) => {
            const sintomas = sintomasDe(ir);
            return (
              <TableRow key={ir.codigo} hover onClick={() => onSelect(ir)} sx={{ cursor: "pointer" }}>
                <TableCell>
                  <Typography variant="body2" fontWeight={500}>
                    {ir.alunoTurma?.aluno?.nome}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Alimentacao value={ir.lanche} />
                </TableCell>
                <TableCell>
                  <Alimentacao value={ir.almoco} />
                </TableCell>
                <TableCell align="center">
                  <BedtimeOutlinedIcon fontSize="small" color={ir.sonoDescanso ? "primary" : "disabled"} />
                </TableCell>
                <TableCell>
                  {sintomas.length > 0 ? (
                    <Stack direction="row" spacing={0.5} useFlexGap flexWrap="wrap">
                      {sintomas.map((s) => (
                        <Chip key={s.campo} size="small" color="error" variant="outlined" label={s.label} />
                      ))}
                    </Stack>
                  ) : (
                    <Typography variant="body2" color="text.secondary">
                      Sem sintomas
                    </Typography>
                  )}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default IntegralRotinaTable;
